import type { useTranslations } from 'next-intl';

export type ListingAccentBadgeKind = 'featured' | 'priceDrop' | 'specialOffer';

export type ListingAccentBadgeSource = {
  priceDropCount?: number | null;
  hasSpecialOffers?: boolean | null;
  isPaidAndNotDemoted?: boolean | null;
};

type HdpT = ReturnType<typeof useTranslations<'hdp'>>;

/**
 * Single-pick accent badge for `ListingCard`:
 * Price Drop > Special Offer > Featured. `newUnitCount` is deliberately not
 * part of this priority — `ListingCard` checks it separately ahead of this
 * function (still relevant on the SRP card), and it no longer appears at
 * the top of the HDP at all (HP-8273; still shown per-unit in the units table).
 */
export function getListingAccentBadge(
  listing: ListingAccentBadgeSource,
  t: HdpT,
): { kind: ListingAccentBadgeKind; label: string } | null {
  if ((listing.priceDropCount ?? 0) > 0) return { kind: 'priceDrop', label: t('priceDropBadge') };
  if (listing.hasSpecialOffers) return { kind: 'specialOffer', label: t('specialOffer') };
  if (listing.isPaidAndNotDemoted) return { kind: 'featured', label: t('featured') };
  return null;
}
